const getters = {
  paginateUrl: state => {
    let request = `?page=${state.page}&take=${state.take}&search=${state.search}&sort=${state.sort}&sortType=${state.sortType}`
    if (state.filter) request = `${request}${state.filter}`
    return request
  },
  getModel: state => state.model,
}
export default getters
